/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import { Breakpoint } from 'react-socks';

class DeleteModal extends React.Component {
    constructor(props) {
        super(props);

        this.draggableRef = React.createRef();

    }

    componentDidMount() {
        window.location.hash = "confirm";
    }

    componentDidUpdate() {

        // catch a back button
        if (window.location.hash !== "#confirm") {
            this.props.cancelAction();
        }

    }

    componentWillUnmount() {

        let cleanUrl = window.location.href.substring(0, window.location.href.indexOf("#"));
        window.history.replaceState({}, '', cleanUrl);

    }

    render() {
        return (
            <div className="dlvr-modal">
                <Breakpoint desktop only>
                    <Draggable nodeRef={this.draggableRef} handle=".dlvr-delete-modal" cancel=".dlvr-delete-close, .action-cancel, .action-delete">
    					<div ref={this.draggableRef} className="dlvr-delete-modal" role="dialog" aria-modal="true">
                            <div role="button" aria-label="close modal" className="dlvr-delete-close" onClick={this.props.cancelAction}>
                                <i className="fa fa-times"></i>
                            </div>
                            <div className="dlvr-delete-copy" role="dialog">
                                {this.props.modalCopy}
                            </div>
                            <div className="dlvr-delete-actions">
                                <div role="button" aria-label="cancel delete" className="action-cancel" onClick={this.props.cancelAction}>
                                    {this.props.cancelLabel}
                                </div>
                                <button type="button" className="btn-delete action-delete" onClick={this.props.confirmAction}>
                                    {this.props.confirmLabel}
                                </button>
                            </div>
    					</div>
    				</Draggable>
                </Breakpoint>
				<Breakpoint mobile only>
                    <div className="dlvr-delete-modal" role="dialog" aria-modal="true">
                        <div role="button" aria-label="close modal" className="dlvr-delete-close" onClick={this.props.cancelAction}>
                            <i className="fa fa-times"></i>
                        </div>
                        <div className="dlvr-delete-copy" role="dialog">
                            {this.props.modalCopy}
                        </div>
                        <div className="dlvr-delete-actions">
                            <div role="button" aria-label="cancel delete" className="action-cancel" onClick={this.props.cancelAction}>
                                {this.props.cancelLabel}
                            </div>
                            <button type="button" className="btn-delete action-delete" onClick={this.props.confirmAction}>
                                {this.props.confirmLabel}
                            </button>
                        </div>
                    </div>
                </Breakpoint>
			</div>
        );
    }

};

DeleteModal.propTypes = {
    modalCopy: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    cancelAction: PropTypes.func,
    confirmAction: PropTypes.func,
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string
};

DeleteModal.defaultProps = {
        modalCopy: '',
        cancelAction: null,
        confirmAction: null,
        confirmLabel: "Delete",
        cancelLabel: "Don't Delete"
};

export default DeleteModal;
